import React from "react";
import { ShieldCheck, Clock, Users, MapPin, Handshake } from "lucide-react";
import { trustFeatures, partnershipLines, company } from "../mock";
import Reveal from "./Reveal";

const iconMap = {
  "shield-check": ShieldCheck,
  clock: Clock,
  users: Users,
  "map-pin": MapPin,
  handshake: Handshake,
};

const WhyChooseUs = () => {
  return (
    <section id="why" className="relative bg-gradient-to-br from-[#0a6bb0] via-[#0d8cc9] to-[#0a4d8c] py-20 md:py-28 overflow-hidden">
      {/* soft radial glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#7fe9ff]/25 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-8">
        <Reveal>
          <div className="text-center mb-16">
            <p className="font-cond uppercase tracking-[0.3em] text-[#d6f7ff] text-sm mb-3">
              Why TNT Legacy
            </p>
            <h2 className="font-display text-4xl md:text-6xl text-white text-glow-white">
              A TEAM YOU CAN <span className="text-[#4fd4ff] text-glow">TRUST</span>
            </h2>
            <div className="h-1.5 w-24 bg-gradient-to-r from-[#0aa5e0] to-[#4fd4ff] rounded-full mx-auto mt-5 glow-cyan-sm" />
          </div>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 md:gap-8">
          {trustFeatures.map((f, i) => {
            const Icon = iconMap[f.icon];
            return (
              <Reveal key={f.label} delay={i * 100}>
                <div className="flex flex-col items-center text-center gap-4 group">
                  <div className="grid place-items-center h-20 w-20 rounded-full border-2 border-white/40 bg-white/10 backdrop-blur-sm group-hover:bg-white group-hover:border-white group-hover:glow-cyan-sm transition-all duration-300">
                    <Icon
                      className="h-9 w-9 text-white group-hover:text-[#0a6bb0] transition-colors"
                      strokeWidth={1.8}
                    />
                  </div>
                  <p className="font-cond uppercase tracking-wider text-slate-200 text-sm leading-tight">
                    {f.label}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>

        {/* Partnership banner */}
        <Reveal>
          <div className="mt-20 rounded-3xl bg-gradient-to-r from-[#062038] to-[#0a3a63] p-10 md:p-14 flex flex-col md:flex-row items-center justify-between gap-8 shadow-2xl shadow-[#062038]/40">
            <div>
              {partnershipLines.map((line) => (
                <p
                  key={line}
                  className="font-script text-3xl md:text-4xl text-white leading-tight"
                >
                  {line}
                </p>
              ))}
            </div>
            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 md:flex-col md:items-end md:gap-3">
              <div className="flex items-center gap-4">
                {company.footerValues.map((v, i) => (
                  <React.Fragment key={v}>
                    <span className="font-cond uppercase tracking-widest text-[#7fd8f7] text-sm md:text-base">
                      {v}
                    </span>
                    {i < company.footerValues.length - 1 && (
                      <span className="h-4 w-px bg-white/30" />
                    )}
                  </React.Fragment>
                ))}
              </div>
              <p className="font-cond uppercase tracking-[0.25em] text-white/90 text-sm md:text-base border-t border-white/20 pt-3">
                {company.location}
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default WhyChooseUs;
